
import { defineComponent, nextTick, onMounted, ref, watch, inject } from 'vue';
import useWallet from '@/composables/wallet';
import useCluster from '@/composables/cluster';
import { initGemFarm } from '@/common/gem-farm';
import { PublicKey } from '@solana/web3.js';
import ConfigPane from '@/components/ConfigPane.vue';
import FarmerDisplay2 from '@/components/gem-farm/FarmerDisplay2.vue';
import Vault2  from '@/components/gem-bank/Vault2.vue';
import { INFT } from '@/common/web3/NFTget';
import { stringifyPKsAndBNs, findFarmerPDA } from '@gemworks/gem-farm-ts';
import { Token } from '@solana/spl-token';
import { u64 } from "@solana/spl-token";
import axios from 'axios';


export default defineComponent({
  components: { Vault2, FarmerDisplay2, ConfigPane },
  setup() {
    const { wallet, getWallet } = useWallet();
    const { cluster, getConnection } = useCluster();

    let gf: any;

    watch([wallet, cluster], async () => {
      await freshStart();
    });

    //needed in case we switch in from another window
    onMounted(async () => {
      await freshStart();
    });

    // --------------------------------------- farmer details    
    var farm = inject('curationFarm', 'string'); 
    const walletAddress = inject('walletAddress', 'string');
    var tokenMintAddress = inject('tokenMint', 'string');
    const farmAcc = ref<any>();

    const farmerIdentity = ref<string>();
    const farmerAcc = ref<any>();
    const farmerState = ref<string>();

    const availableA = ref<string>();
    const availableB = ref<string>();    

    const selectedNFTs = ref<INFT[]>([]);
    const vaultNFTs = ref<INFT[]>([]);
    let numWATR = ref<string>();;
    let unpaidNFTs: string[] = new Array();
    let readyToGrow: string[] = new Array();
    const showStakeBtn = ref<boolean>(); // if true burn btn is hidden
    const showGrowBtn = ref<boolean>(); 

    let processing = ref<boolean>();

    const updateAvailableRewards = async () => {
      availableA.value = farmerAcc.value.rewardA.accruedReward
        .sub(farmerAcc.value.rewardA.paidOutReward)
        .toString();
    };

    const fetchFarn = async () => {
      farmAcc.value = await gf.fetchFarmAcc(new PublicKey(farm));
    };
    const fetchFarmer = async () => {
      const [farmerPDA] = await findFarmerPDA(
        new PublicKey(farm),
        getWallet()!.publicKey!
      );
      farmerIdentity.value = getWallet()!.publicKey?.toBase58();
      farmerAcc.value = await gf.fetchFarmerAcc(farmerPDA);
      farmerState.value = gf.parseFarmerState(farmerAcc.value);
      await updateAvailableRewards();
      await grabNftsFromDB();
    };

    const freshStart = async () => {

      if (getWallet() && getConnection()) {
        gf = await initGemFarm(getConnection(), getWallet()!);
        farmerIdentity.value = getWallet()!.publicKey?.toBase58();

        //reset stuff
        farmAcc.value = undefined;
        farmerAcc.value = undefined;
        farmerState.value = undefined;
        availableA.value = undefined;
        availableB.value = undefined;
        processing.value = false;

        try {
          await fetchFarn();
          await fetchFarmer();
        } catch (e) {
          initFarmer();
        }
      }
    };

    const initFarmer = async () => {
      await gf.initFarmerWallet(new PublicKey(farm!));
      await fetchFarmer();
    };

    // --------------------------------------- staking
    // begin staking
    const beginStaking = async () => {
      var flag = true;
      processing.value = true; // show processing screen 


      for (const nft of vaultNFTs.value) {
        let nftMint = nft.mint.toBase58();
        let nftData: any;
        // update nft data
        await axios.get(`https://metajuanaserver.com/dbapi/single_read.php?seedAddress=${nftMint}`).then((response: any) => {
            nftData = response.data;
        });
        try{
          await axios.get(`https://metajuanaserver.com/dbapi/single_read.php?seedAddress=${nftMint}`).then((response: any) => {
            if (response.data.paid2D != 1) {flag = false};
          });
        } catch(e) {
          console.log(e);
        }
      }
      if (flag == true) {
        try{
          await gf.stakeWallet(new PublicKey(farm!))
        for (const nft of vaultNFTs.value) {
          let nftMint = nft.mint.toBase58();
          let nftData: any;
          // update nft data
          await axios.get(`https://metajuanaserver.com/dbapi/single_read.php?seedAddress=${nftMint}`).then((response: any) => {
              nftData = response.data;
          });
          nftData.staked2D = 1;
          try {
            await axios.post(`https://metajuanaserver.com/dbapi/update.php`, nftData).then((response: any) => {
            //console.log(response); todo remove 
            });
          } catch {
            console.log("updateFailed in CURATION ENDSTAKING() -------------------------");
          }
        }

        }
         catch(e) {
          console.log(e);
        }
        
        };
      
      await fetchFarmer();
      selectedNFTs.value = [];

      processing.value = false;

    };

    const endStaking = async () => {
      processing.value = true; // show processing screen 

      await gf.unstakeWallet(new PublicKey(farm!));
      // for each nft set staked2D to true in db
      for (const nft of vaultNFTs.value) {
        let nftMint = nft.mint.toBase58();
        let nftData: any;
        // update nft data
        await axios.get(`https://metajuanaserver.com/dbapi/single_read.php?seedAddress=${nftMint}`).then((response: any) => {
            nftData = response.data;
        });
        nftData.staked2D = 1;
        try {
          await axios.post(`https://metajuanaserver.com/dbapi/update.php`, nftData).then((response: any) => {
          //console.log(response); todo remove 
          });
        } catch {
          console.log("updateFailed in CURATION ENDSTAKING() -------------------------");
        }
      }
      await fetchFarmer();
      selectedNFTs.value = [];

      processing.value = false;
    };

    const claim = async () => {
      await gf.claimWallet(
        new PublicKey(farm!),
        new PublicKey(farmAcc.value.rewardA.rewardMint!),
        new PublicKey(farmAcc.value.rewardB.rewardMint!)
      );
      await fetchFarmer();
    };

    const handleRefreshFarmer = async () => {
      await fetchFarmer();
    };
    // --------------------------------------- adding extra gem

    const handleNewSelectedNFT = (newSelectedNFTs: INFT[]) => {
      console.log(`selected ${newSelectedNFTs.length} NFTs`);
      selectedNFTs.value = newSelectedNFTs;
      grabSelectedNftsFromDB()
    };

    const currentVaultNFTs = (newVaultNFTs: INFT[]) => {
      console.log(` ${newVaultNFTs.length} NFTs in vault`);

      vaultNFTs.value = newVaultNFTs;
      grabNftsFromDB();
    };
    
    async function grabSelectedNftsFromDB(){

      processing.value = true; // show processing screen 

      if (selectedNFTs.value.length <1){
          showGrowBtn.value = false;
      }
      else{
        for(const nft of selectedNFTs.value) {
          if ((nft.onchainMetadata as any).data.creators[0].address == 'DynFnTUjzoXPDtAGg9mN6kF3L4oweR8Wau4DhcDwd5TU'){
              let nftMint = nft.mint.toBase58();
              let paid2D: number;
              let staked2D: number;
            try {
                await axios.get(`https://metajuanaserver.com/dbapi/single_read.php?seedAddress=${nftMint!}`).then((response: any) => {
                  paid2D = response.data.paid2D;
                  staked2D = response.data.staked2D;
                });
              }catch(e) {
                console.log("unable to grab from db");
              }
              if (paid2D! == 1 && staked2D! == 1) {            // IF USER HAS YET TO PAY FOR NFT
                readyToGrow.push(nftMint)   // add nft mint to unpaid array
              }
          }

          if (readyToGrow.length > 0){
            showGrowBtn.value = true;
          }
          else{
            showGrowBtn.value = false;
          }
        }
      }

      console.log(showGrowBtn.value)

      processing.value = false;
    }

    // jam into single tx
    const claimPlants = async () => {

      processing.value = true; // show processing screen 

      for (const nft of readyToGrow) {        
        let paid2D: number;
        let burnedseed: number;
        let transfered2D: number;
        let address2D: string;
        let nftData: any;
        let staked2D: any;
        let nftMint = nft;

        try {
          await axios.get(`https://metajuanaserver.com/dbapi/single_read.php?seedAddress=${nftMint}`).then((response: any) => {
            nftData = response.data;
            paid2D = response.data.paid2D;
            burnedseed = response.data.burnedseed;
            transfered2D = response.data.transfered2D;
            address2D = response.data.address2D;
            staked2D =  response.data.staked2D;
          });
        } catch(e) {
          console.log(e);
          console.log("unable to grab NFT From database");
          continue;
        }

        // if nft.mint in the database paid2d = true AND burnedseed = false and transfered2d = false
        if (paid2D! == 1 && staked2D == 1 && burnedseed! == 0 && transfered2D! == 0) {
          
          try{    
            await gf.sendCall(nftData);

            await gf.transferNft(nft, walletAddress);
            nftData.burnedseed = 1; //set burnedseed to true
          
            await gf.sendCall(nftData);

          } catch(e){
            console.log(e);
          } 
        }
        
      }
      await fetchFarmer();

      processing.value = false;

    };

    //TODO: TEST THIS
    async function grabNftsFromDB() {
      processing.value = true;
      //TODO: remove strings testing only
      //unpaidNFTs = ["7egiE27KT5So7sythFV1hswsG6cgVpLQbSpr3v6tkFAy", "FUpC9KRwpm1za8GJVeJD7bZFFY1SUhQxiTBy3qJ5f55g"];
      unpaidNFTs = [];
      readyToGrow = [];
      
      for(const nft of vaultNFTs.value) {
        let nftMint = nft.mint.toBase58();
        let paid2D: number;

        try {
          await axios.get(`https://metajuanaserver.com/dbapi/single_read.php?seedAddress=${nftMint!}`).then((response: any) => {
            paid2D = response.data.paid2D;
          });
        }catch(e) {
          console.log("unable to grab from db");
        }

        //paid2D = 0; // TODO: remove testing only
    
        if (paid2D! == 0) {            // IF USER HAS YET TO PAY FOR NFT
          unpaidNFTs.push(nftMint)   // add nft mint to unpaid array
        }
      }

      // console.log("TEST GRABNFT FUNCTIONALITY --------------------------------");
      // for(const nft of unpaidNFTs) {
      //   console.log(nft);
      // }
      
      // set burn amount
      numWATR.value = String(unpaidNFTs.length * 420);

      // update buttons
      if (unpaidNFTs.length == 0 && vaultNFTs.value.length > 0) {   // user has nfts in valt and all are paid
        showStakeBtn.value = true;
      }
      else{
            showStakeBtn.value = false;    
      }

      processing.value = false;
    };

    const addSingleGem = async (
      gemMint: PublicKey,
      gemSource: PublicKey,
      creator: PublicKey
    ) => {
      await gf.flashDepositWallet(
        new PublicKey(farm!),
        '1',
        gemMint,
        gemSource,
        creator
      );
      await fetchFarmer();
    };

    const addGems = async () => {
      await Promise.all(
        selectedNFTs.value.map((nft) => {
          const creator = new PublicKey(
            // currently simply taking the 1st creator
            (nft.onchainMetadata as any).data.creators[0].address
          );
          console.log('creator is', creator.toBase58());

          addSingleGem(nft.mint, nft.pubkey!, creator);
        })
      );
      console.log(
        `added another ${selectedNFTs.value.length} gems into staking vault`
      );
    };

    const burnToken = async () => {
      processing.value = true;

      // for (const nft of vaultNFTs.value) {
      //   let paid2D: any;

      //   let nftMint = nft.mint.toBase58();
      //   try{
      //     await axios.get(`http://3.214.125.207/dbapi/single_read.php?seedAddress=${nftMint!}`).then((response: any) => {
      //       paid2D = response.data.paid2D;
      //     });

      //     if (paid2D == 0) {numNfts += 1};  // if user has not paid on nft
      //   } catch {
      //     console.log("unable to locate NFT:" + nftMint);
      //   }
      // }

      // if upaidNFTS is > 0  iterate through each nft mint burn 420 and update metadata
      if (unpaidNFTs.length > 0) {          
                  
          try {
            await gf.burnToken(tokenMintAddress, 420000000 * unpaidNFTs.length); //420000000000 
                    for(const nft of unpaidNFTs) {
                      // update nft data
                      let nftData: any;
                      await axios.get(`https://metajuanaserver.com/dbapi/single_read.php?seedAddress=${nft}`).then((response: any) => {
                          nftData = response.data;
                      });
                      nftData.paid2D = 1;
                      try {
                        await axios.post(`https://metajuanaserver.com/dbapi/update.php`, nftData).then((response: any) => {
                        //console.log(response); todo remove 
                        });
                      } catch {
                        console.log("updateFailed");
                      }
                    }
          } catch(e) {
            console.log(e);
            console.log("unable to burn token");
          }
     
      }
      await fetchFarmer();

      processing.value = false;
    }

    return {
      wallet,
      farm,
      farmAcc,
      farmer: farmerIdentity,
      farmerAcc,
      farmerState,
      availableA,
      availableB,
      initFarmer,
      beginStaking,
      endStaking,
      claim,
      handleRefreshFarmer,
      selectedNFTs,
      handleNewSelectedNFT,
      currentVaultNFTs,
      addGems,
      burnToken,
      numWATR,
      showStakeBtn,
      showGrowBtn,
      claimPlants,
      processing,
    };
  },
});
